import { render, staticRenderFns } from "./404.vue?vue&type=template&id=de8857a0&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=de8857a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8857a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de8857a0')) {
      api.createRecord('de8857a0', component.options)
    } else {
      api.reload('de8857a0', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=de8857a0&scoped=true&", function () {
      api.rerender('de8857a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/404.vue"
export default component.exports